// src/locales/en/purchaseOrder.js
export const purchaseOrder = {
  // Page titles and navigation
  createPurchaseOrder: 'Create Purchase Order',
  createPurchaseOrderDescription: 'Create a new purchase order for inventory',
  editPurchaseOrder: 'Edit Purchase Order',
  editPurchaseOrderDescription: 'Update purchase order details',
  purchaseOrderDetails: 'Purchase Order Details',
  backToPurchaseOrders: 'Back to Purchase Orders',
  allPurchaseOrders: 'All Purchase Orders',
  addPurchaseOrder: 'Add Purchase Order',

  // List page
  manageAndTrackPurchaseOrders: 'Manage and track all purchase orders for inventory',
  noPurchaseOrdersYet: 'No purchase orders yet',
  noPurchaseOrdersYetDescription: 'Create your first purchase order to start managing inventory purchases.',
  noPurchaseOrdersFound: 'No purchase orders found',
  noPurchaseOrdersFoundDescription: 'No purchase orders match your current filters. Try adjusting your search criteria.',
  createFirstPurchaseOrder: 'Create First Purchase Order',
  searchByPoNumber: 'Search by PO number...',
  allWarehouses: 'All Warehouses',
  allSuppliers: 'All Suppliers',
  allStatuses: 'All Statuses',
  dateRange: 'Date Range',
  totalItems: 'Total Items',
  receiveOrder: 'Receive Order',

  // Edit messages
  loadingOrder: 'Loading Order',
  cannotEditOrder: 'This purchase order cannot be edited',
  confirmUpdate: 'Are you sure you want to update this purchase order?',
  confirmUpdateTitle: 'Confirm Update',
  purchaseOrderUpdated: 'Purchase order {{orderNumber}} updated successfully',
  failedToUpdate: 'Failed to update purchase order',
  failedToLoadOrder: 'Failed to load purchase order',
  updateOrder: 'Update Order',
  updateWarning: 'This will update the purchase order with the new details.',
  updatingOrder: 'Updating...',
  orderNotEditable: 'This order cannot be edited ({{status}})',
  
  // Form sections
  basicInformation: 'Basic Information',
  purchaseOrderItems: 'Purchase Order Items',
  financialDetails: 'Financial Details',
  
  // Basic information fields
  warehouse: 'Warehouse',
  warehouseRequired: 'Warehouse is required',
  selectWarehouse: 'Select warehouse',
  
  supplier: 'Supplier',
  supplierRequired: 'Supplier is required',
  selectSupplier: 'Select or search supplier',
  createNewSupplier: 'Create New Supplier',
  supplierName: 'Supplier Name',
  supplierContact: 'Contact Person',
  supplierEmail: 'Email',
  supplierPhone: 'Phone',
  changeSupplier: 'Change supplier',
  createSupplierWithName: 'Create "{{name}}"',
  
  orderDate: 'Order Date',
  orderDateRequired: 'Order date is required',
  
  expectedDeliveryDate: 'Expected Delivery Date',
  expectedDeliveryDateOptional: 'Expected delivery date (optional)',
  
  status: 'Status',
  statusDraft: 'Draft',
  statusPending: 'Pending',
  statusReceived: 'Received',
  statusPartial: 'Partially Received',
  statusCancelled: 'Cancelled',
  
  notes: 'Notes',
  notesPlaceholder: 'Add any additional notes about this purchase order...',
  
  autoReceive: 'Auto-receive',
  autoReceiveTooltip: 'Automatically mark this order as received and update stock immediately upon creation',
  autoReceiveWarning: 'This will immediately add items to inventory',
  
  // Items section
  searchProducts: 'Search Products',
  searchProductsPlaceholder: 'Search by name, SKU, or barcode...',
  addItem: 'Add Item',
  removeItem: 'Remove Item',
  atLeastOneItemRequired: 'At least one item is required',
  
  product: 'Product',
  productRequired: 'Product is required',
  selectProduct: 'Select product',
  
  quantity: 'Quantity',
  quantityRequired: 'Quantity is required',
  quantityMinimum: 'Quantity must be greater than 0',
  
  unitPrice: 'Unit Price',
  unitPriceRequired: 'Unit price is required',
  unitPriceMinimum: 'Unit price must be greater than or equal to 0',
  
  lineTotal: 'Line Total',
  lineNotes: 'Item Notes',
  lineNotesPlaceholder: 'Add notes for this item...',
  
  // Financial details
  subtotal: 'Subtotal',
  extraCharges: 'Extra Charges',
  extraChargesPlaceholder: 'e.g., 500.00',
  extraChargesDescription: 'Extra Charges Description',
  extraChargesDescriptionPlaceholder: 'Describe the extra charges (delivery, tax, etc.)',
  
  discountAmount: 'Discount Amount',
  discountAmountPlaceholder: 'e.g., 100.00',
  discountDescription: 'Discount Description',
  discountDescriptionPlaceholder: 'Describe the discount reason',
  
  grandTotal: 'Grand Total',
  
  // Product search
  noProductsFound: 'No products found',
  searchingProducts: 'Searching...',
  productSku: 'SKU',
  productStock: 'Current Stock',
  productPrice: 'Cost Price',
  
  // Supplier dialog
  supplierDialogTitle: 'Create New Supplier',
  supplierDialogDescription: 'Add a new supplier to your system',
  supplierNameRequired: 'Supplier name is required',
  supplierNamePlaceholder: 'Enter supplier company name',
  supplierContactPlaceholder: 'Enter contact person name',
  supplierEmailPlaceholder: 'Enter supplier email',
  supplierPhonePlaceholder: 'Enter supplier phone',
  supplierCreating: 'Creating supplier...',
  searchingSuppliers: 'Searching suppliers...',
  
  // Actions
  saveAsDraft: 'Save as Draft',
  submitOrder: 'Submit Order',
  updateOrder: 'Update Order',
  cancel: 'Cancel',
  
  // Success messages
  purchaseOrderCreated: 'Purchase order {{orderNumber}} created successfully',
  purchaseOrderCreatedAndReceived: 'Purchase order {{orderNumber}} created and received successfully',
  purchaseOrderUpdated: 'Purchase order updated successfully',
  purchaseOrderSaved: 'Purchase order saved as draft',
  supplierCreated: 'Supplier created successfully',
  
  // Error messages
  failedToCreate: 'Failed to create purchase order',
  failedToUpdate: 'Failed to update purchase order',
  failedToLoadData: 'Failed to load required data',
  failedToLoadOrder: 'Failed to load purchase order',
  failedToCreateSupplier: 'Failed to create supplier',
  cannotEditReceived: 'Cannot edit a received purchase order',
  cannotEditCancelled: 'Cannot edit a cancelled purchase order',
  cannotEditActiveReceipts: 'This purchase order has active GRNs or return-to-vendor records. Cancel or void them before editing.',
  
  // Validation messages
  pleaseFixErrors: 'Please fix the errors before submitting',
  unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
  confirmSubmit: 'Are you sure you want to submit this purchase order?',
  confirmSubmitTitle: 'Confirm Submission',
  confirmDraft: 'Save this purchase order as draft?',
  
  // Loading states
  loadingWarehouses: 'Loading warehouses...',
  loadingSuppliers: 'Loading suppliers...',
  loadingProducts: 'Loading products...',
  loadingOrder: 'Loading purchase order...',
  loadingMessage: 'Please wait while we load the required data...',
  loadingOrderMessage: 'Please wait while we load the order data...',
  submittingOrder: 'Submitting order...',
  
  // Empty states
  noWarehousesAvailable: 'No warehouses available',
  noSuppliersAvailable: 'No suppliers found',
  noItemsAdded: 'No items added yet',
  addItemsToOrder: 'Add items to this purchase order',
  
  // Tooltips and hints
  warehouseHint: 'Select the warehouse where stock will be received',
  supplierHint: 'Search and select the supplier for this order',
  orderDateHint: 'Date when the purchase order was created',
  expectedDeliveryHint: 'Expected date when items will be delivered',
  autoReceiveHint: 'Check this to immediately update stock upon order creation',
  
  // Table headers
  itemNumber: '#',
  itemProduct: 'Product',
  itemQuantity: 'Qty',
  itemUnitPrice: 'Unit Price',
  itemLineTotal: 'Total',
  itemActions: 'Actions',
  
  // Currency
  currency: 'Rs.',
  
  // Common
  required: 'Required',
  optional: 'Optional',
  loading: 'Loading...',
  search: 'Search',
  create: 'Create',
  update: 'Update',
  save: 'Save',
  delete: 'Delete',
  view: 'View',
  edit: 'Edit',
  
  // Order number
  orderNumber: 'Order Number',
  poNumber: 'PO Number',
  generatedOrderNumber: 'Generated Order Number',

  // Receive action
  confirmReceiveTitle: 'Confirm Receive Order',
  confirmReceive: 'Are you sure you want to mark this purchase order as received? All items will be fully received and stock will be updated.',
  receivingOrder: 'Receiving...',
  purchaseOrderReceived: 'Purchase order {{orderNumber}} has been marked as received',
  failedToReceive: 'Failed to receive purchase order',

  // Details page
  purchaseOrderDetailsDescription: 'View full details of this purchase order',
  orderInformation: 'Order Information',
  supplierInformation: 'Supplier Information',
  warehouseInformation: 'Warehouse Information',
  itemsOrdered: 'Items Ordered',
  financialSummary: 'Financial Summary',
  auditInformation: 'Audit Information',
  receivedQuantity: 'Received Qty',
  orderedQuantity: 'Ordered Qty',
  receivedBy: 'Received By',
  receivedDate: 'Received Date',
  cancelledBy: 'Cancelled By',
  cancelledAt: 'Cancelled At',
  cancellationReason: 'Cancellation Reason',
  noCancellationReason: 'No reason provided',
  confirmCancelTitle: 'Cancel Purchase Order',
  confirmCancel: 'Are you sure you want to cancel this purchase order? This action cannot be undone.',
  cancellationReasonLabel: 'Reason for cancellation (optional)',
  cancellationReasonPlaceholder: 'Enter a reason for cancelling...',
  cancellingOrder: 'Cancelling...',
  purchaseOrderCancelled: 'Purchase order {{orderNumber}} has been cancelled',
  failedToCancel: 'Failed to cancel purchase order',
  noNotes: 'No notes',
  contactPerson: 'Contact Person',
  variation: 'Variation',
  notSpecified: 'Not specified',
  partiallyReceived: 'Partially received',
  fullyReceived: 'Fully received',
  notYetReceived: 'Not yet received',

  // Export / Download
  downloadPdf: 'Download PDF',
  downloadExcel: 'Download Excel',
  downloading: 'Downloading...',

  // Procurement — GRN / RTV / Payment actions (Phase 11)
  createGoodsReceivedNote: 'Create GRN',
  createReturnToVendor: 'Create RTV',
  recordPayment: 'Record Payment',
  paymentRecordedSuccessfully: 'Payment recorded successfully',
  failedToRecordPayment: 'Failed to record payment',
  paymentMethodRequired: 'Please select a payment method',
  paymentAmountRequired: 'Please enter a valid payment amount',

  // Payment status badge
  paymentStatus: 'Payment',
  paymentStatus_unpaid: 'Unpaid',
  paymentStatus_partial: 'Partially Paid',
  paymentStatus_paid: 'Paid',
  paidAmount: 'Paid',
  balanceAmount: 'Balance Due',

  // Related documents section
  relatedDocuments: 'Related Documents',
  goodsReceivedNotes: 'Goods Received Notes',
  returnsToVendor: 'Returns to Vendor',
  debitNotes: 'Debit Notes',
  paymentHistory: 'Payment History',
  noRelatedDocuments: 'None yet',
  paymentDate: 'Payment Date',
  paymentMethod: 'Payment Method',
  paymentAmount: 'Amount',
  paymentReference: 'Reference',

  // Supplier payments (Payment Records section + Payments modal)
  paymentRecords: 'Payment Records',
  poTotal: 'PO Total',
  payments: 'Payments',
  paymentDetails: 'Payment Details',
  outstandingBalance: 'Outstanding Balance',
  debitNotePaymentMethod: 'Debit Note',
  selectDebitNote: 'Select Debit Note',
  searchDebitNote: 'Search debit notes...',
  noAvailableDebitNotes: 'No available debit notes for this supplier',
  confirmPayment: 'Confirm Payment',
  completePaymentFields: 'Please complete all payment fields',
  paymentRecordedSuccess: 'Payment recorded successfully',

  // Activity history (procurement audit trail)
  activityHistory: "Activity History",
  noActivity: "No activity recorded yet",
  loadMore: "Load more",
  auditHistory: "Audit History",
  totalChanges: "Total Changes",
  lastModified: "Last Modified",
  auditEmpty: "Empty",
  auditBy: "by {{name}}",
  auditTag_payment: "Payment Record",
  auditTag_grn: "GRN",
  auditTag_rtv: "Return to Vendor",
  auditTag_debitNote: "Debit Note",
  auditField_paymentDate: "Payment Date",
  previous: "Previous",
  next: "Next",
  pageOf: "Page {{page}} of {{total}}",
  noPaymentRecords: "No payments recorded yet",
  returnedToVendor: "Returned to Vendor",
  voided: "Voided",
  audit_CREATE: "Purchase order created",
  audit_UPDATE: "Purchase order updated",
  audit_STATUS_CHANGED: "Status changed",
  audit_CANCEL: "Purchase order cancelled",
  audit_RECEIVE_FULL: "Received in full",
  audit_PAYMENT_ADDED: "Payment recorded",
  audit_PAYMENT_UPDATED: "Payment updated",
  audit_PAYMENT_REMOVED: "Payment removed",
  audit_GRN_CREATED: "Goods received note created",
  audit_GRN_CANCELLED: "Goods received note cancelled",
  audit_RTV_CREATED: "Return to vendor created",
  audit_RTV_VOIDED: "Return to vendor voided",
  audit_DEBIT_NOTE_ISSUED: "Debit note issued",
  audit_DEBIT_NOTE_APPLIED: "Debit note applied",
  audit_DEBIT_NOTE_CANCELLED: "Debit note cancelled",
  auditField_purchaseOrderNumber: "PO Number",
  auditField_status: "Status",
  auditField_grandTotal: "Grand Total",
  auditField_totalAmount: "Subtotal",
  auditField_extraCharges: "Extra Charges",
  auditField_discountAmount: "Discount",
  auditField_orderDate: "Order Date",
  auditField_expectedDeliveryDate: "Expected Delivery",
  auditField_notes: "Notes",
  auditField_supplierName: "Supplier",
  auditField_extraChargesDescription: "Extra Charges Note",
  auditField_discountDescription: "Discount Note",
  auditField_autoReceive: "Auto-receive",
  auditField_warehouseName: "Warehouse",
  auditField_items: "Items",
  auditField_itemCount: "Items",
  auditField_amount: "Amount",
  auditField_method: "Payment Method",
  auditField_reference: "Reference",
  auditField_grnNumber: "GRN Number",
  auditField_rtvNumber: "RTV Number",
  auditField_debitNoteNumber: "Debit Note",
  auditField_totalDebitAmount: "Debit Amount",
  auditField_quantityReceived: "Quantity Received",
  auditField_sourceType: "Source",
  auditField_proofUrl: "Proof File",
  auditField_quantity: "Quantity",
  auditField_unitPrice: "Unit Price",
  auditField_lineTotal: "Line Total",
  auditItemAdded: "Item added",
  auditItemRemoved: "Item removed",
  auditItemUpdated: "Item updated",
  auditViewFile: "View file",
  auditLegacyItems: "Items updated ({{count}}) — details not recorded",
  quantityMustBeGreaterThanZero: "Quantity must be at least 1",
  quantityMustBeWholeNumber: "Quantity must be a whole number",
  unitPriceRequired: "Unit price is required",
  openFullDetails: "Open full details",
};